var map = {
	"./australia.jpg": 7327,
	"./canada.jpg": 8423,
	"./europe.jpg": 4847,
	"./ireland.jpg": 2892,
	"./uk.jpg": 6637,
	"./usa.jpg": 8188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 281;